<template lang="html">
  <div>
    <v-app-bar app flat color="white" class="app-bar-no-padding">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="d-flex align-center">
              <div class="font-18 font-weight-bold">QRIS</div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container>
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <template v-if="!$isEmpty(order.payment_log) && order.status !== 'X'">
            <div class="mb-6" style="padding: 10px 0">
              <div
                :class="[
                  '_image-qris-container',
                  { 'qris-expired': formattedTimeLeft === $t('v2.expired') }
                ]"
              >
                <div class="_triangle-top">
                  <img :src="require('@/assets/img/png/triangle_top.png')" alt="" />
                </div>
                <div class="_image-qris-text">
                  {{ $t('v2.scan_this_qris') }}
                </div>
                <div class="col-square _image-qris">
                  <div class="content-square pa-6">
                    <img :src="order.payment_log.qr_image" alt="Qris" class="image-responsive" />
                  </div>
                </div>
                <div class="_triangle-bottom">
                  <img :src="require('@/assets/img/png/triangle_bottom.png')" alt="" />
                </div>
              </div>
            </div>
            <v-btn
              :disabled="formattedTimeLeft === $t('v2.expired')"
              :href="order.payment_log.qr_image"
              download="QRIS.png"
              outlined
              block
              color="#0078CE"
              height="40"
              class="ol-elevation-1 text-none font-weight-700 border-radius-5 mb-4 letter-space-0"
            >
              <v-icon left> mdi-download </v-icon>
              {{ $t('v2.download_qris') }}
            </v-btn>
            <div class="pa-4 container-countdown text-center mb-4">
              <div
                :class="[
                  'text-container-countdown',
                  { 'text-expired': formattedTimeLeft === $t('v2.expired') }
                ]"
              >
                {{ formattedTimeLeft }}
              </div>
              <div class="subtext-container-countdown">
                {{
                  formattedTimeLeft === $t('v2.expired')
                    ? $t('v2.your_payment_time_has_expired')
                    : $t('v2.complete_payment_immediately')
                }}
              </div>
            </div>
            <v-btn
              v-if="
                formattedTimeLeft !== $t('v2.expired') &&
                order.status === 'P' &&
                !order.is_paid &&
                order.payment_mode_id !== 10
              "
              color="primary"
              text
              block
              height="40"
              class="text-none font-weight-700 mb-4 letter-space-0"
              @click="changePayment()"
            >
              {{ $t('v2.use_other_payment_method') }}
            </v-btn>
          </template>
          <div class="mb-4">
            <div class="text-center font-16 font-weight-600 mb-4">
              {{ $t('v2.how_to_pay_with_qris') }}
            </div>
            <ol class="list-qris-guide">
              <li>
                {{ $t('v2.press_the_download_qris_button') }}
              </li>
              <li>
                {{ $t('v2.oppen_an_eWallet_ebanking') }}
              </li>
              <li>
                {{ $t('v2.look_for_the_qris_scan_option') }}
              </li>
              <li>
                {{ $t('v2.after_scanning_the_total_transaction_price_will_appear') }}
              </li>
              <li>
                {{ $t('v2.confirm_and_pay') }}
              </li>
              <li>
                {{ $t('v2.you_have_successfully_paid') }}
              </li>
            </ol>
          </div>
          <v-btn
            color="#F5F5F5"
            height="40"
            block
            class="text-none mt-6 font-weight-bold border-radius-5"
            style="margin-bottom: 80px"
            @click="goToOrder(order.id)"
          >
            {{ $t('dialog.detail_order') }}
          </v-btn>
        </v-col>
      </v-row>
      <div class="menu-bottom">
        <div class="wrap-menu-bottom">
          <v-container :class="['d-flex', { 'pa-0': $vuetify.breakpoint.width > 600 }]">
            <v-row :class="[{ 'ma-0 fill-height': $vuetify.breakpoint.width > 600 }]">
              <v-col cols="12" class="py-0" :class="[{ 'px-0': $vuetify.breakpoint.smAndDown }]">
                <div class="d-flex fill-height align-center justify-center">
                  <v-btn
                    v-if="
                      order.status_mark === 'waiting_for_payment' &&
                      formattedTimeLeft !== $t('v2.expired')
                    "
                    tile
                    depressed
                    block
                    height="100%"
                    class="text-none btn-order-bottom"
                    @click="getOrder()"
                  >
                    {{ $t('v2.check_payment_status') }}
                  </v-btn>
                  <v-btn
                    v-else-if="
                      formattedTimeLeft === $t('v2.expired') &&
                      (order.status === 'x' || order.status === 'z')
                    "
                    tile
                    depressed
                    block
                    height="100%"
                    class="text-none btn-order-bottom"
                    @click="changePayment(1)"
                  >
                    Pesan ulang
                    <span class="ml-2">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.89 10.105C19.676 9.6 19.411 9.11 19.101 8.649L17.443 9.768C17.681 10.12 17.884 10.495 18.047 10.883C18.215 11.281 18.344 11.696 18.43 12.113C18.518 12.546 18.563 12.991 18.563 13.437C18.563 13.883 18.518 14.33 18.43 14.761C18.344 15.179 18.216 15.592 18.046 15.992C17.884 16.378 17.681 16.753 17.443 17.104C17.209 17.451 16.938 17.778 16.64 18.077C16.343 18.374 16.016 18.643 15.667 18.879C15.315 19.117 14.941 19.32 14.553 19.483C14.158 19.65 13.744 19.779 13.324 19.866C12.46 20.041 11.538 20.041 10.678 19.866C10.256 19.779 9.84101 19.65 9.44501 19.482C9.05801 19.319 8.68401 19.116 8.33201 18.878C7.98501 18.645 7.65901 18.375 7.36101 18.078C7.06201 17.778 6.79201 17.45 6.55801 17.105C6.32101 16.754 6.11801 16.379 5.95301 15.99C5.78601 15.594 5.65801 15.181 5.57101 14.76C5.48301 14.329 5.43801 13.884 5.43801 13.437C5.43801 12.99 5.48301 12.545 5.57201 12.113C5.65801 11.693 5.78601 11.279 5.95301 10.883C6.11801 10.493 6.32201 10.118 6.55801 9.769C6.79201 9.422 7.06201 9.095 7.36001 8.797C7.65601 8.5 7.98301 8.23 8.33201 7.995C8.68201 7.759 9.05701 7.555 9.44601 7.39C9.84101 7.223 10.256 7.094 10.676 7.008C10.783 6.986 10.892 6.976 11 6.959V10L16 6L11 2V4.938C10.757 4.967 10.514 5 10.275 5.049C9.72501 5.162 9.18301 5.33 8.66701 5.549C8.15801 5.764 7.66801 6.03 7.21201 6.339C6.75801 6.645 6.33201 6.996 5.94501 7.383C5.55701 7.771 5.20601 8.197 4.90001 8.649C4.59101 9.106 4.32601 9.595 4.11001 10.104C3.89101 10.622 3.72301 11.163 3.61101 11.712C3.49501 12.275 3.43701 12.856 3.43701 13.438C3.43701 14.02 3.49601 14.6 3.61101 15.163C3.72401 15.714 3.89201 16.255 4.11001 16.77C4.32501 17.279 4.59101 17.769 4.90001 18.226C5.20501 18.676 5.55601 19.102 5.94501 19.494C6.33401 19.882 6.75901 20.233 7.21001 20.537C7.66901 20.848 8.15901 21.114 8.66601 21.327C9.18201 21.545 9.72301 21.714 10.275 21.827C10.839 21.941 11.419 22 12 22C12.581 22 13.161 21.941 13.727 21.826C14.278 21.712 14.819 21.544 15.331 21.327C15.838 21.114 16.329 20.848 16.788 20.537C17.241 20.231 17.667 19.88 18.056 19.491C18.444 19.102 18.795 18.677 19.101 18.225C19.413 17.763 19.677 17.273 19.889 16.77C20.109 16.25 20.278 15.709 20.389 15.162C20.504 14.599 20.563 14.018 20.563 13.437C20.563 12.857 20.504 12.276 20.389 11.712C20.277 11.166 20.108 10.625 19.89 10.105Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </div>
      <!-- <div class="__menu-bottom menu-full">
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
          <v-btn color="primary" x-large block class="text-none" @click="goOrderDetail()">
            {{ $t('dialog.detail_order') }}
          </v-btn>
        </v-col>
      </div> -->
    </v-container>
  </div>
</template>
<script>
import { order, orderCalculation } from '@/api/order'
import { getVoucherDetail } from '@/api/voucher'
import { shipperList } from '@/api/shipping'
import { prepareCartItem } from '@/utils/order'
export default {
  data() {
    return {
      expired_time: 0,
      timerOrderInterval: null,
      order: {},
      temporary_cart: {},
      temporary_shipping: {}
    }
  },
  computed: {
    formattedTimeLeft() {
      let days = Math.floor(this.expired_time / (1000 * 60 * 60 * 24))
      let hours = Math.floor((this.expired_time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((this.expired_time % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((this.expired_time % (1000 * 60)) / 1000)
      let result
      if (this.expired_time < 0) {
        result = this.$t('v2.expired')
      } else {
        days = days === 0 ? '' : days + ' : '
        hours = hours < 10 ? (hours === 0 ? '' : '0' + hours + ' : ') : hours + ' : '
        minutes = minutes < 10 ? '0' + minutes + ' : ' : minutes + ' : '
        seconds = seconds < 10 ? '0' + seconds : seconds
        result = days + hours + minutes + seconds
      }
      return result
    }
  },
  beforeDestroy() {
    clearInterval(this.timerOrderInterval)
  },
  sockets: {
    connect: function () {
      console.log('socket connected')
    },
    admin_pusher_status(data) {
      const success = 'netzme_' + this.order.id + '_status = success'
      const error = 'netzme_' + this.order.id + '_status = error'
      if (data.title === success) {
        this.order.is_paid = 1
        this.$store.dispatch('saveDataOrder', this.order)
        this.$router.push({ name: 'order_success' }).catch(() => {})
      } else if (data.title === error) {
        this.$router.push({ name: 'order_payment_failed' }).catch(() => {})
      }
    },
    customEmit: function (data) {
      console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
    }
  },
  created() {
    this.getOrder()
  },
  methods: {
    goToOrder(id) {
      this.$router.push({ name: 'order', params: { id: id } }).catch(() => {})
    },
    async getOrder() {
      try {
        const { data } = await order(this.$route.params.id)
        this.order = data.data
        if (!this.$isEmpty(this.order.payment_log) && this.order.payment_log.expired_at) {
          this.getExpiryTime(this.order.payment_log.expired_at)
        }
        if (this.order.is_paid) {
          clearInterval(this.timerOrderInterval)
        }
      } catch (e) {
        this.order = {}
        this.$store.dispatch('showAlert', {
          type: 'error',
          show: true,
          message: e.message
        })
      }
    },
    getExpiryTime(time) {
      var countDownDate = new Date(time).getTime()
      const _this = this
      this.timerOrderInterval = setInterval(function () {
        var now = new Date().getTime()
        _this.expired_time = countDownDate - now
        if (_this.expired_time < 0) {
          clearInterval(_this.timerOrderInterval)
        }
      }, 1000)
    },
    async checkVoucher(id) {
      try {
        const { data } = await getVoucherDetail(id)
        this.$set(this.temporary_cart, 'discount_voucher_id', id)
        this.$set(this.temporary_cart, 'discount_voucher_detail', data.data)
      } catch (e) {
        this.$store.dispatch('showAlert', {
          type: 'error',
          show: true,
          message: e.message
        })
      }
    },
    async getShipper() {
      try {
        const { data } = await shipperList(this.temporary_cart)
        const shipperSupport = ['Instant', 'Same Day', 'Regular', 'Express', 'Cargo']
        const getData = data.data.filter(shipper => {
          if (shipperSupport.includes(shipper.name)) {
            if (shipper.item.length > 0) {
              return shipper
            }
          }
        })
        const idx_type = getData.findIndex(e => e.name === this.order.shipping_service_type)
        const idx = getData[idx_type].item.findIndex(
          e => e.courier_id === this.order.shipping_courier_id
        )
        const item = getData[idx_type].item[idx]
        const objShipper = {
          name: item.logistic_name,
          type: item.rate_type,
          shipping_courier_id: item.rate_id,
          shipping_service_type: item.rate_type,
          shipment_method: item.rate_type,
          shipment_working_hour: item.working_hour,
          price: item.final_price,
          logo: item.image_url,
          must_use_insurance: item.must_use_insurance,
          insurance_fee: item.insurance_fee,
          insurance_details: item.insurance_details,
          insurance_included: item.insurance_included
        }
        this.temporary_shipping = objShipper

        this.temporary_cart.shipping_courier_id = item.rate_id
        this.temporary_cart.shipping_service_type = this.order.shipping_service_type
        this.temporary_cart.shipping_insurance = false
      } catch (e) {
        this.$store.dispatch('showAlert', {
          type: 'error',
          show: true,
          message: e.message
        })
      }
    },
    async changePayment(isCart = 0) {
      this.temporary_cart.item = []
      for (const item of this.order.items) {
        this.temporary_cart.item.push(prepareCartItem(item))
      }
      this.temporary_cart.remark = this.order.remark
      this.temporary_cart.currency_id = this.order.currency_id
      this.temporary_cart.notes = ''
      this.temporary_cart.shipping_address = ''
      this.temporary_cart.shipping_address_is_different = 1
      this.temporary_cart.without_shipping = 1
      if (!isCart) {
        this.temporary_cart.previousOrderId = this.order.id
        this.temporary_cart.shipping_address_id = null
        this.temporary_cart.shipping_address = this.order.shipping_address
        this.temporary_cart.shipping_lat = Number(this.order.shipping_lat)
        this.temporary_cart.shipping_lon = Number(this.order.shipping_lon)
        this.temporary_cart.shipping_subdistrict_id = this.order.shipping_subdistrict_id
        this.temporary_cart.shipping_city_id = this.order.shipping_city_id
        this.temporary_cart.shipping_country_id = this.order.shipping_country_id
        this.temporary_cart.shipping_name = 'Kantor'
        this.temporary_cart.shipping_note = this.order.shipping_note
        this.temporary_cart.notes = ''
        this.temporary_cart.without_shipping = this.order.remark === 'DELIVERY' ? 0 : 1
        this.temporary_cart.total = Number(this.order.total_amount)
        this.temporary_cart.shipping_radius = this.order.shipping_radius

        if (this.order.discount_voucher_id) {
          this.checkVoucher(this.order.discount_voucher_id)
        }

        if (this.order.remark === 'DELIVERY') {
          if (Number(this.order.shipping_delivery_type) === 2) {
            await this.getShipper()
          } else {
            this.temporary_shipping.id = 1
            this.temporary_shipping.type = 'free'
            this.temporary_shipping.name = 'Gratis Antar'
            this.temporary_shipping.remark = 'DELIVERY'
            this.temporary_shipping.logo = 'free_delivery'
            this.temporary_shipping.detail = 'Gratis'
            this.temporary_shipping.price = '0'
            this.temporary_shipping.fprice = 'IDR 0'
          }
        } else {
          this.temporary_shipping.id = 3
          this.temporary_shipping.type = 'SelfTake'
          this.temporary_shipping.name = 'Ambil Sendiri'
          this.temporary_shipping.remark = 'SELF PICK-UP'
          this.temporary_shipping.logo = 'pickup'
          this.temporary_shipping.detail = ''
          this.temporary_shipping.price = '0'
          this.temporary_shipping.fprice = 'IDR 0'
        }
        this.$store.commit('SET_TEMPORARY_SHIPPING', this.temporary_shipping)
      }

      try {
        await orderCalculation(this.temporary_cart, {
          globalLoading: false
        })
        this.$store.dispatch('saveDataCart', this.temporary_cart)
        if (isCart) {
          this.$router.push({ name: 'shopping_cart' })
        } else {
          this.$router.push({ name: 'payment_method' })
        }
      } catch (e) {
        this.$store.dispatch('showAlert', {
          type: 'error',
          show: true,
          message: e.message
        })
      }
      this.$store.dispatch('remove_order')
    }
  }
}
</script>
